import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'

export default function NoDataRow({colSpan}) {
	const { t } = useTranslation();
	return (
		<TableRow>
			<TableCell colSpan={colSpan} style={{textAlign: 'center'}}>{t('no_data')}</TableCell>
		</TableRow>
	)
}

NoDataRow.propTypes = {
	colSpan: PropTypes.number.isRequired,
}